<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :hasButtons="false"
  >
    <template #tabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" has-border cols="auto">
        <v-tab-item>
          <modeling-results-ranges-settings type="sewer" v-bind="{ ...modelingResultsParamsNames }" />
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>
<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import ModelingResultsRangesSettings from '@/components/ModelingResultsRangesSettings';

export default {
  name: 'SewerModelingSettings',
  components: {
    AdminWrapper,
    GreyTabs,
    ModelingResultsRangesSettings,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@SEWER_MODELING.verbose_name'),
    moduleEnabler() {
      return {
        name: 'sewer_modeling_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    modelingResultsParamsNames() {
      return {
        linksParams: ['depth', 'flow', 'velocity'],
        nodesParams: ['depth', 'flow'],
      };
    },
    inputs() {
      return [
        {
          name: 'tabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    tabs() {
      return [{ name: this.$i18n.t('admin.sewerModelingResultsBrowser') }];
    },
  },
  data: () => ({
    tab: 0,
  }),
};
</script>
